import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { updateBrokerConnectData } from '../../actions/brokerConnect/brokerConnectActionCreators';
import { configs } from '../../constants/configs/configs';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';

//components
import Week from './components/Week';
import InputPhoneNumber from './components/InputPhoneNumber';
import Alert from './Alert';
import Slider from './components/Slider';
import ErrorMessage from './components/ErrorMessage';

import { ACTIVITY_TYPES } from '../../constants/common/statusTypes';
import { CLOSED, SELECT } from '../../constants/common/dateTimeValues';

const Availability = props => {

    const { brokerInfo, actions } = props;
    const { status, phoneNumber, tempPhoneNumber= '' } = brokerInfo;
    const { endpoints } = configs;

    const [ showMessage, setMessage ] = useState(false);
    const [ showPhoneErrorMessage, setPhoneErrorMessage ] = useState(false);

    const isDisabled = status === ACTIVITY_TYPES.INACTIVE ? true : false;
    const location = useLocation();

    const isValidAvailability = () => {

        return brokerInfo.brokerAvailabilities.reduce( (bool, day ) => {
            if(day.fromTime ===  CLOSED || day.fromTime === CLOSED) {
                return bool;
            } else if(day.fromTime === SELECT || day.fromTime === SELECT) {
                return false;
            } else if(day.fromTime > day.toTime || day.fromTime === day.toTime) {
                return false;
            } else {
                return bool;
            }
        }, true);


    };

    const phoneNumberHandler = () => {
        if( (phoneNumber && phoneNumber.length === 10 && tempPhoneNumber === '' ) || tempPhoneNumber && tempPhoneNumber.length === 10 ) {
            setPhoneErrorMessage(false);
            actions.updateBrokerConnectData(endpoints.BROKERCONNECT_PARTICIPATION_DETAILS, { ...brokerInfo, phoneNumber: tempPhoneNumber || phoneNumber });
            
        } else {
            setPhoneErrorMessage(true);
        }
    };


    const saveHoursHandler = e => {
        e.preventDefault();
        if(isValidAvailability()) {
            setMessage(false);
            actions.updateBrokerConnectData(endpoints.BROKERCONNECT_HOURS, { ...brokerInfo });
        } else {
            setMessage(true);
        }
    };


    const clearErrorMessage = () => {
        showPhoneErrorMessage ? setPhoneErrorMessage(false) : null;
    };


    return (
        <div className="availibility-container gi-panel" id="main-content">
            {    
                status === ACTIVITY_TYPES.ACTIVE && location.state  && location.state.redirectedFromParticipation ?
                    <Alert 
                        header="brokerconnect.availability.error_msg.successfully_enrolled.header" 
                        message="brokerconnect.availability.error_msg.successfully_enrolled.message" 
                        variation="success"
                    />
                    : status === ACTIVITY_TYPES.INACTIVE &&
                    <Alert 
                        header="brokerconnect.availability.error_msg.not_enrolled.header" 
                        message="brokerconnect.availability.error_msg.not_enrolled.message" 
                        variation="error"
                    />
            }
            
            <div className="availibility__slider">
                <div className="header">
                    <h4 className="heading">
                        <FormattedMessage 
                            id='brokerconnect.availability.header'
                        />
                        
                    </h4>
                </div>
                <div className="avaibility_availibility__slider__item">
                    <Slider { ...brokerInfo } />
                    <div className="float-right">
                        <a href="#availability" data-tip data-for="broker_availability_tooltip">
                            <FontAwesomeIcon icon="question-circle" />
                            <span className="usa-sr-only"><FormattedMessage id="common.more.info" /></span>
                        </a>
                    </div>    
                </div>
               
                <ReactTooltip
                    place="top"
                    type="dark"
                    effect="solid"
                    id="broker_availability_tooltip"
                >
                    <FormattedMessage
                        id="brokerconnect.availability.slider.tooltip"
                    />
                </ReactTooltip>          
            </div>

            <div className="padding-105">
                <p>
                    <FormattedMessage 
                        id='brokerconnect.availability.msg.select_hours'
                    />
                </p>
                <p>
                    <FormattedMessage 
                        id='brokerconnect.availability.msg.not_available'
                    />
                </p>
            </div>

            {
                showMessage && <ErrorMessage message="brokerconnect.availability.error_msg.availability_invalid" />
            }
           
            
            <Week className="" { ...brokerInfo } />
            <div className="controls-container">
                <div className="grid-row controls padding-105">
                    <div className="grid-col buttons-group txt-right">
                        <button disabled={ isDisabled } className="usa-button gi-button gi-button__primary" onClick={ e => saveHoursHandler(e) }>
                            <FormattedMessage
                                id='brokerconnect.availability.save_availability_btn'
                            />
                        </button>
                    </div>
                </div>
            </div>
            
            <div className="phonenumber-container">
                <div className="header">
                    <h4 className="heading">
                        <FormattedMessage 
                            id='brokerconnect.availability.update_phone_number_header'
                        />
                    </h4>
                </div>
                <div className="grid-row padding-105 padding-y-4">
                    <div className="mobile:grid-col-12 tablet:grid-col-9">
                        <div className="gi-component">
                            <label className="gi-regular_input__label" htmlFor="phoneNumber">
                                <FormattedMessage
                                    id='brokerconnect.availability.msg.update_phone_number'
                                />
                            </label>
                            <InputPhoneNumber id="phoneNumber" { ...brokerInfo }  errorHandler={ clearErrorMessage } />
                            {
                                showPhoneErrorMessage && <ErrorMessage message='brokerconnect.error_msg.invalid_phonenumber' />
                            }
                        </div>
                    </div>
                    <div className="mobile:grid-col-12 tablet:grid-col-3 txt-right">
                        <button disabled={ isDisabled } className="usa-button gi-button gi-button__primary" onClick={ phoneNumberHandler }>
                            <FormattedMessage
                                id='brokerconnect.availability.update_phone_number_btn'
                            />
                        </button>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

const mapStateToProps = state => {
    return({
        brokerInfo: state.brokerConnect
    });
};

const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        updateBrokerConnectData
    }, dispatch)
});

export default connect(mapStateToProps, matchDispatchToProps)(Availability);